<template>
    <div class="event1 scrollstyle" :class="lang">
        <!-- <img class="logo" :src="logoSrc"/> -->
        <div class="cont" :class="lang">
            <div class="title" :class="lang" v-html="$t('event2_text1')"></div>
            <p v-html="$t('event2_text2')"></p>
        </div>
        <div class="link" :class="lang">
            <a :href="AIHref" target="_blank"  v-html="$t('event2_text3')"></a><br/>
            <a :href="SokHref" target="_blank"  v-html="$t('event2_text4')"></a>
        </div>
        <div class="mission">
            <div class="title" :class="lang" v-html="$t('event2_text6_1')" v-if="!isExperience && isShow"></div>
            <div class="userInfo" v-if="!isExperience && isShow">
                <img v-if="userInfo.picture" :src="userInfo.picture" >
                <img v-else class="defProfile" src="@/assets/img/default-profile.png" >
                <div class="info">
                    <div class="name">{{ userInfo.name }}</div>
                    <div class="id">{{ userInfo.id }}</div>
                </div>
            </div>
            <div class="check">
                <div class="check-box">
                    <base-ex ref="baseEXE" v-show="!isExperience && isShow"></base-ex>
                    <div class="convert" :class="{'disabled': isExperience}" @click="checkEvent()" style="width: 100%;max-width: 311px;">
                        <div v-if="!isExperience" class="text" :class="lang" v-html="$t('event2_text7')"></div>
                        <div v-else class="text" :class="lang" v-html="$t('event2_text14')"></div>
                    </div>
                    <div v-if="!isExperience && isShow" v-html="$t('event4_text14', {url: serviceHref})"></div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    // import {reactive, ref, computed, watch, watchEffect} from 'vue'
    import { useDialog, NButton } from 'naive-ui'
    import { inject, ref, h, defineComponent, computed, onMounted } from 'vue'
    import { useRoute } from 'vue-router'
    import { useStore } from "vuex"
    import { useI18n } from "vue-i18n"
    import naiveFnc from "@/utils/naiveFnc"
    import baseex from '@/components/baseEX.vue'

    export default defineComponent({
        components: {
            'base-ex': baseex
        },
        setup() {
            // 元件宣告
            const { t } = useI18n()
            const route = useRoute()
            const store = useStore()
            const { crtDialog } = naiveFnc();
            const dialog = useDialog()

            // 變數宣告
            var AIHref = ''
            var SokHref = ''
            var serviceHref = ''
            const isExperience = ref(false)
            const isShow = ref(false)
            const checkKey = computed(() => store.getters["coreApi/baseEXCheckKey"]) // 需要被檢查的欄位
            const baseEXE = ref()

            // 全螢幕spin的狀態
            // const spinState = inject('spinState')
    
            // 全螢幕的spin
            const changeSpinState = inject('changeSpinState')
    
            let userInfo = store.state.coreApi.userInfo
            const eventInfo = store.getters['activity/event4']
            const benifits = store.getters['coreApi/benifits']
            const baseEx = computed(() => store.getters['coreApi/baseEx'])
            let lang = route.params.lang
            // var logoSrc = require('@/assets/img/event2_logo_' + lang + '.png')
            // var demosrc = require('@/assets/img/event2_demo_' + lang + '.png')            

            switch(lang){
                case 'tw':
                    AIHref = 'https://www.habook.com/zh-tw/faq.php?act=view&id=186'
                    SokHref = 'https://www.habook.com/zh-tw/news.php?act=view&id=424'
                    serviceHref = 'https://www.habook.com/zh-tw/contact_us.php'
                break
                case 'cn':
                    AIHref = 'https://www.habook.com.cn/zh-cn/faq.php?act=view&id=192'
                    SokHref = 'https://www.habook.com.cn/cloud.php?act=view&id=2'
                    serviceHref = 'https://www.habook.com.cn/event.php?act=view&id=35'
                break
                default:
                    AIHref = 'https://www.habook.com/en/faq.php?act=view&id=186'
                    SokHref = 'https://www.habook.com/en/news.php?act=view&id=424'
                    serviceHref = 'https://www.habook.com/en/contact_us.php'
            }

            // 檢測是否已體驗
            var event4s = benifits.hiteach.filter( x => (x.func === "soklite" && x.get) || (x.func === "aitext" && x.get))
            if(event4s.length === 2) {
                let limitDate = Math.floor(new Date(2024, 1, 28, 23, 59, 59).getTime()/1000)
                let isExp = true
                event4s.forEach((e)=>{
                    if(e.get < limitDate){
                        isExp = false
                    }
                })

                isExperience.value = isExp
            }

            // 內部取消dialog
            function destroy() {
                dialog.destroyAll()
            }

            // 判斷是否有填寫進階資訊
            onMounted(()=>{
                let show = false
                if(baseEx.value){
                    checkKey.value.forEach(c=>{
                        switch(c){
                            case 'country':{
                                let pattern_En = new RegExp("[A-Za-z]")
                                if (!pattern_En.test(baseEx.value[c])) {
                                    show = true
                                }
                            }
                            break
                            case 'schoolCode':
                                // 暫不檢查
                                // if(baseEx.value['country'] == 'TW' && (baseEx.value[c] == '' || baseEx.value[c] == null)){
                                //     show = true
                                // }
                            break
                            default:
                                if(baseEx.value[c] == '' || baseEx.value[c] == null) {
                                    show = true
                                }
                        }
                    })
                } else {
                    show = true
                }
                
                isShow.value = show
            })

            //method
            // 立刻體驗
            function checkEvent() { // 檢查活動是否已完成
                if(!isExperience.value) {
                    baseEXE.value?.baseExFormRef.validate(async(errors) => {
                        if (!errors) {
                            changeSpinState() // 開啟全屏spin

                            // 需要寫入baseEX嗎
                            if(isShow.value){
                                let data = {}
                                if(baseEx.value){
                                    let bKeys = Object.keys(baseEx.value)

                                    bKeys.forEach(k=>{
                                        if(baseEXE.value.baseExValue[k]) {
                                            data[k] = baseEXE.value.baseExValue[k]
                                        } else {
                                            data[k] = baseEx.value[k]
                                        }
                                    })
                                } else {
                                    data = baseEXE.value.baseExValue
                                }

                                // 寫入baseEX
                                await store.dispatch('coreApi/setUserContact', data).then(() => {
                                    isShow.value = false
                                }).catch(e =>{
                                    console.log(e)
                                })
                            }

                            // 完成活動
                            // 文句分析 AITEXT AITEXT-E2
                            // 蘇格拉底小數據 SOKLITE SOKLITE-E2
                            let eventNums = []
                            for(var hit of benifits.hiteach){
                                switch(hit.func){
                                    case 'aitext':
                                        if(hit.get == null || hit.exp == null){
                                            eventNums.push(eventInfo[hit.func].base)
                                        } else {
                                            eventNums.push(eventInfo[hit.func].extend)
                                        }
                                    break;
                                    case 'soklite':
                                        if(hit.get == null || hit.exp == null){
                                            eventNums.push(eventInfo[hit.func].base)
                                        } else {
                                            eventNums.push(eventInfo[hit.func].extend)
                                        }
                                    break;
                                }
                            }

                            var errStr = ''
                            var isSuccess = false

                            // 申請活動完成
                            for(var coupon of eventNums) {
                                let res = await exchangeCoupon(coupon)
                                if(res.state === 0) {
                                    res = await exchangeVoucher(res.data.voucher)
                                    if(res.state === 0) {
                                        isSuccess = true
                                    } else {
                                        errStr = res.msg
                                    }
                                } else {
                                    errStr = res.msg
                                }

                                // 因為連續呼叫等1秒
                                await delay(1);
                            }

                            if(isSuccess){
                                //更新個人額外活動資訊
                                await store.dispatch("coreApi/getUsersetting", 'benefits')
                                dialog.create({
                                    class: 'eventDialog',
                                    maskClosable: false,
                                    closable: false,
                                    showIcon: false,
                                    content: ()=> {
                                        let resAry = [
                                            h('p',{'style': 'font-size: 20px;'}, t('event2_text8')),
                                            h('span' ,{'innerHTML': t('event2_text15')}),
                                        ]
                                        return h('div',{'style': 'text-align: center;'}, resAry)
                                    },
                                    action: () => h(NButton, { text: true, color: '#00c4fb', onClick: destroy}, t('ok'))
                                })
                                isExperience.value = true
                            } else {
                                crtDialog(t('notice'), errStr)
                            }

                            // 關閉全屏spin
                            changeSpinState()
                        }
                    })
                }
            }

            function delay(n){
                return new Promise(function(resolve){
                    setTimeout(resolve,n*1000);
                });
            }

            async function exchangeCoupon(coupon) {
                var errStr = ""
                var result
                    // {
                    //     eventId: '',
                    //     expire: 0,
                    //     voucher: '',
                    //     info: [],
                    //     eventName:''
                    // }
                

                await store.dispatch('coreApi/getCoupon', coupon).then( res => {
                    if(res.error) {
                        let error = res.error.toString()
                        switch(error) {
                            case '9':
                                errStr = t('error_9')
                            break
                            case '14':
                                errStr = t('error_13')
                            break
                            case '15':
                                errStr = t('error_11')
                            break
                            case '20':
                                errStr = t('error_12')
                            break
                        }
                    } else {
                        result = res
                    }
                }).catch( e =>{
                    console.log(e)
                    errStr = t('error_3')
                })
                
                if(errStr != "") {
                    return {state: 1, msg: errStr}
                } else {
                    return {state: 0, data: result}
                }
            }

            async function exchangeVoucher(voucher) {
                var errStr = ""

                await store.dispatch('coreApi/exchangeVoucher', voucher).then( res => {
                    if(res.error) {
                        let error = res.error.toString()
                        switch(error) {
                            // case '8':
                            //   errStr = '票卷已過期'
                            // break
                            // case '9':
                            //   errStr = '你已使用過該票券'
                            // break
                            // case '12':
                            //     errStr = '活動尚未開始'
                            // break
                            // case '16':
                            //     errStr = '降規格(權益折損)'
                            // break
                            default:
                            errStr = t('error_10')
                        }
                    }
                }).catch( e =>{
                    console.log(e)
                    errStr = t('error_3')
                })

                if(errStr != "") {
                    return {state: 1, msg: errStr}
                } else {
                    return {state: 0}
                }
            }

            return {
                // logoSrc,
                userInfo,
                checkEvent,
                AIHref,
                SokHref,
                serviceHref,
                lang,
                // demosrc,
                benifits,
                isExperience,
                isShow,
                baseEXE
            }
        },
    })
</script>
<style lang="less" scoped>
    .event1{
        padding: 0 20px;
        letter-spacing: 2px;
        line-height: 1.35;
        &.en{
            letter-spacing: 0;
        }
        .logo {
            max-width: 100%;
            height: auto;
            margin-top: 30px;
            margin-bottom: 40px;
        }
        .cont{
            color: #788189;
            font-size: 13px;
            &.en{
                font-size: 12px;
            }
            .title{
                color: #000000;
                font-size: 13px;
                font-weight: bolder;
                &.en{
                    font-size: 13px;
                }
            }
        }
        .link{
            text-align: left;
            margin-bottom: 30px;
            a {
                font-size: 13px;
                color: #00c4fb;
                font-weight: bolder;
                text-decoration: underline;
            }
            &.en{
                a{
                    font-size: 12px;
                }
            }
        }
        .mission{
            .title{
                color: #000000;
                font-size: 13px;
                font-weight: bolder;
                margin-bottom: 20px;
                &.en{
                    font-size: 14px;
                }
            }
            .userInfo{
                display: flex;
                align-items: center;
                margin-bottom: 20px;
                justify-content: center;
                img{
                    width: 60px;
                    display: block;
                    border-radius: 50%;
                    margin-right: 20px;
                }
                .defProfile{
                    border: 1px solid #b2b1b0;
                }
                .info{
                    .name{
                        color: #000000;
                        font-size: 14px;
                        font-weight: bolder;
                        margin-bottom: 3px;
                    }
                    .id{
                        color: #788189;
                        font-size: 12px;
                    }
                }
            }
            .check{
                &-box{
                    display: flex;
                    align-items: center;
                    margin-bottom: 25px;
                    flex-direction: column;
                    .info{
                        display: flex;
                        width: 88%;
                        .icon{
                            width: 40px;
                            margin-right: 5px;
                        }
                        .detail{
                            font-size: 13px;
                            color: #000000;
                            font-weight: bolder;
                            /deep/small{
                                font-weight: 300;
                                font-size: 12px;
                                color: #788189;
                            }
                            &.en{
                                font-size: 12px;
                            }
                        }
                    }
                    .state{
                        display: flex;
                    }
                }
            }
            .convert{
                display: flex;
                background-color: #00c4fb;
                height: 50px;
                border-radius: 5px;
                justify-content: center;
                align-items: center;
                margin-bottom: 10px;
                &.disabled{
                    background-color: #b2b1b0;
                }
                .text{
                    color: #ffffff;
                    font-size: 15px;
                    &.en{
                        font-size: 15px;
                    }
                }
            }
        }
    }
</style>
<style lang="less">
    .schoolOption{
        .n-drawer-header__main{
            width: 100%;
        }
    }
</style>